import store from '../store/index'
import axios from 'axios'
import packageFile from '../../package.json'
// axios.defaults.baseURL = process.env.VUE_APP_API_SERVER

const api = axios.create({
  baseURL: process.env.VUE_APP_API_SERVER,
  headers: { Pragma: 'no-cache', 'Content-Type': 'application/json', 'appversion': packageFile.version }
})

api.interceptors.response.use((response) => response,
  (error) => {
    const { response } = error
    const err = response.data.error
    if (err.status === 503 && err.errorCode === 'SERVER_MAINTENANCE') {
      store.commit('mutationByKeyValue', [{ key: 'isMaintenanced', value: true }])
    } else {
      store.commit('mutationByKeyValue', [{ key: 'isMaintenanced', value: false }])
    }
    return Promise.reject(error)
  })

// 대기목록 가져오기
// https://mealantcloud.atlassian.net/wiki/spaces/PI/pages/1851031553/-+wd
export function getWaitingList (restaurantIdx) {
  return api.get(`/v1/restaurants/${restaurantIdx}/waiting-display`)
}

export function sendDisplayType (restaurantIdx, data) {
  // 불필요한 API로 호출안하도록 합니다
  return api.put(`${process.env.VUE_APP_NEW_B_API_SERVER}/api/restaurant/${restaurantIdx}/kioskType`, data)
}

// 광고영상 목록 받아오기
export function getAdvertiseList (restaurantIdx) {
  return api.get(`${process.env.VUE_APP_ADS_API_SERVER}/v1/video/playList/${restaurantIdx}`)
}

export function sendAdvertisementLog (data) {
  return api.post(`${process.env.VUE_APP_ADS_API_SERVER}/v1/ads-monitoring/logs`, data)
}

// 대기확정코드 조회
// https://mealantcloud.atlassian.net/wiki/spaces/PI/pages/1792999528/OTP+API
export function getOtpNumber (restaurantIdx) {
  return api.get(`/v1/restaurants/${restaurantIdx}/otp`)
}
